import { record, string, struct } from 'io-ts/Decoder';

export const Request = struct({
	data: struct({
		inputs: record(string),
		total: string,
	}),
});
